import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import ModalCTA from '../../modal/ModalCTA';
import ModalButton from '../../modal/ModalButton';

import {
  setModal,
  addToast,
  updateStorePlaylists,
  incrementStorePlaylists,
  removeHistoryTracks
} from "../../../../actions/index";
import useKeyPress from '../../../../hooks/useKeyPress';
import useCartStore from '../..//cart/hooks/useCartStore';

function ConnectedKeysManager({
  id, nameParent = null, onMassDelete,
  api, isConnected, selectedItems, setModal, addToast, updateStorePlaylists, incrementStorePlaylists, removeHistoryTracks
}) {
  const deletePress = useKeyPress('Backspace');

  const updateParent = (data, itemsModified) => {
    if (isConnected && itemsModified.length > 0) {
      itemsModified.forEach( x => { api.del(`/v4/my/playlists/${id}/tracks/${x}/`); } )
    }
    updateStorePlaylists(id, `tracks`, data);
    incrementStorePlaylists(id, `track_count`, itemsModified.length * -1);
  }

  const showModal = (id, selectedItems, validClick) => {
    setModal({ //V2
      content: (
        <ModalCTA
          title={`Remove track(s)`}
          description={`Are you sure you want to remove the selected track(s)?`}
          styleContainer={{marginTop: `-60%`, marginLeft: `-10%`}}
          styleBody={{gap: 32}}
          classModal={`bottom-reduce`}
        >
          <ModalButton label={`Remove`} className={`red-white`} onClick={validClick} keyPress={true} />
          <ModalButton label={`Cancel`} className={`cancel`}  />
        </ModalCTA>
      )
    })
  }

  const deletePlaylistAction = () => {
    const validClick = (id) => {
      onMassDelete(selectedItems.map(x => x.id), selectedItems.map(x => x.item_id), updateParent);
      addToast({ content: <span>{selectedItems.length} track(s) removed from '{nameParent ? nameParent : 'this playlist'}'.</span>, typeClass: 'neutral', iconStyle: { padding: 16, marginRight: 16 } });
    };
    showModal(id, selectedItems, validClick);
  }

  const deleteHistoryAction = () => {
    const validClick = (id) => {
      selectedItems.forEach(x => { removeHistoryTracks(x.id) } );
      addToast({ content: <span>{selectedItems.length} track(s) removed from Recently played.</span>, typeClass: 'neutral', iconStyle: { padding: 16, marginRight: 16 } });
    };
    showModal(id, selectedItems, validClick);
  }

  const {removeItemsToCart} = useCartStore();
  const deleteCartAction = () => {
    if (selectedItems.length > 0) {
      removeItemsToCart(selectedItems.map(x => ({ itemID: x.id, cartItemID: x.cartItemID })), () => { onMassDelete(selectedItems.map(x => x.id), selectedItems.map(x => x.item_id)); });
    }
  }

  if (deletePress && selectedItems.length > 0) {
    if (id === `history-tracks`) {
      deleteHistoryAction();
    } else if (id === 'Cart') {
      deleteCartAction();
    } else {
      deletePlaylistAction();
    }
  }

  return null;
}

ConnectedKeysManager.propTypes = {
  id: PropTypes.any.isRequired,
  onMassDelete: PropTypes.func,
}

const KeysManager = connect(
  state => ({
    api: state.api,
    isConnected: state.isConnected,
    selectedItems: state.selectedItems
  }),
  dispatch => ({
    setModal: content => dispatch(setModal(content)),
    addToast: content => dispatch(addToast(content)),
    updateStorePlaylists: (trackID, property, data) => dispatch(updateStorePlaylists(trackID, property, data)),
    incrementStorePlaylists: (trackID, property, data) => dispatch(incrementStorePlaylists(trackID, property, data)),
    removeHistoryTracks: (id) => dispatch(removeHistoryTracks(id))
  })
)(ConnectedKeysManager);

export default KeysManager;
